
namespace RioERP.Products {
    export class ProductBillingItemSpecificationsColumns {
        static columnsKey = 'Products.ProductBillingItemSpecifications';
    }
}